<!-- Backdrop -->
<div 
  *ngIf="isOpen" 
  class="modal-backdrop fixed inset-0 bg-black bg-opacity-50 z-50"
  (click)="onBackdropClick($event)"
></div>

<!-- Modal -->
<!-- Inline: Tailwind não suporta valores acoplados a elementos externos (top: 64px = altura fixa do navbar) nem @keyframes slideDown definido no SCSS do componente — CSS inline necessário -->
<div 
  *ngIf="isOpen"
  class="user-profile-modal fixed bg-white dark:bg-gray-800 rounded-lg shadow-2xl z-50 min-w-[280px] max-w-[320px]"
  style="top: 64px; right: 16px; animation: slideDown 0.2s ease-out;"
>
  <div class="p-6">
    <!-- Avatar -->
    <div class="flex justify-center mb-4">
      <div class="w-20 h-20 rounded-full border-4 border-blue-200 dark:border-blue-800 bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
        <lucide-icon name="user" class="w-12 h-12 text-gray-400 dark:text-gray-300"></lucide-icon>
      </div>
    </div>

    <!-- Nome do usuário -->
    <div class="text-center mb-1">
      <h3 class="text-lg font-bold text-gray-800 dark:text-gray-100">{{ usuario.nome }}</h3>
    </div>

    <!-- Username -->
    <div class="text-center mb-6">
      <span class="text-sm text-gray-500 dark:text-gray-400">@{{ usuario.username }}</span>
    </div>

    <!-- Divisor -->
    <div class="border-t border-gray-200 dark:border-gray-700 my-4"></div>

    <!-- Botão Conta -->
    <button
      (click)="onConta()"
      class="w-full flex items-center space-x-3 px-4 py-3 text-left text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors"
    >
      <lucide-icon name="key" class="w-4 h-4 text-gray-500 dark:text-gray-400"></lucide-icon>
      <span class="font-medium">Conta</span>
    </button>

    <!-- Botão Sair -->
    <button
      (click)="onLogout()"
      class="w-full flex items-center space-x-3 px-4 py-3 text-left text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors mt-2"
    >
      <lucide-icon name="log-out" class="w-4 h-4 text-gray-500 dark:text-gray-400"></lucide-icon>
      <span class="font-medium">Sair</span>
    </button>
  </div>
</div>

